import { resourceAttributes } from '../constants/setup';

const getExtendedAttributes = (path: string, userId: string) => {
  return {
    ...resourceAttributes,
    path,
    user_id: userId,
  };
};

export { getExtendedAttributes };
